import { For, type JSX } from 'solid-js';
import { LIVE_ZONES, type LiveZone } from '../lib/fleet-live-layout';

// A "Place in" option's zone map (#6779, prototype zoneIcon, `:3634`): the four zones as
// blocks, the option's own one filled in the working hue, the rest a faint ink. Decorative.

const RECT: Readonly<Record<LiveZone, readonly [number, number, number, number]>> = {
  top: [2, 2, 24, 4],
  middle: [2, 8, 16, 6],
  side: [20, 8, 6, 6],
  bottom: [2, 16, 24, 4],
};

export function FleetLiveZoneIcon(props: { readonly zone: LiveZone }): JSX.Element {
  return (
    <svg width="28" height="22" viewBox="0 0 28 22" aria-hidden="true">
      <For each={LIVE_ZONES}>
        {(z) => {
          const [x, y, w, h] = RECT[z];
          return (
            <rect
              x={x}
              y={y}
              width={w}
              height={h}
              rx="1"
              class={z === props.zone ? 'fleet-live__zone-live' : 'fleet-live__zone-off'}
            />
          );
        }}
      </For>
    </svg>
  );
}
